import React, {createContext, useEffect} from 'react';
import './App.css';
import {theme} from "./Tema";
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import {ThemeProvider} from "@mui/system";
import {useEscucharUsuarioToCorreo} from "./Servicios/BD/useEscucharUsuarioToCorreo";
import {useEscucharAuth} from "./Servicios/Auth/Hooks/useEscucharAuth";
import Login from "./Login/Login";
import logo from './Recursos/logo_oscuro.svg'
import logo_redondo from './Recursos/logo_redondo.svg'
import {Grid2} from "@mui/material";
import Dashboard from "./Dashboard/Dashboard";


export const usuarioContext = createContext();

function App() {
    const {email, data} = useEscucharAuth()
    const {usuario} = useEscucharUsuarioToCorreo({correo: email, user: data})


    const valoresProvider = {
        usuario,
    }

    const {Provider} = usuarioContext;


    useEffect(() => {


        if (window.swUpdateReady) {
            window.swUpdateReady = false;
            window.stop();
            window.location.reload();
        }


    }, [])


    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Provider value={valoresProvider}>
                {usuario ?
                    <ThemeProvider theme={theme}>
                        <Dashboard/>
                    </ThemeProvider>

                    :
                    <Login logo={logo} logoRedondo={logo_redondo}/>
                }

            </Provider>
        </Grid2>
    );
}

export default App;
